<template>
    <div class="card border border-bottom mb-2">
        <a class="card-header px-2 pt-1 pb-1 text-dark text-decoration-none" role="tab" id="headingOne" data-toggle="collapse" :href="'#collapseOne' + proj.pj_id" aria-expanded="true" aria-controls="collapseOne"
            @click="toggleIcon(proj.pj_id)">

            <div class="let-space-1"><small>Pj.{{proj.pj_id}}</small></div>
            <div> {{proj.pj_nm}} </div>
            <div class="text-right text-primary d-flex">
                <span>
                    <small>
                        <i class="fas fa-building"></i>
                        {{proj.pj_group}}
                    </small>
                </span>
                <span class="flex-fill">
                    <small>
                        {{proj.per_cnt}}人
                        <i v-if="downIcon" class="fas fa-angle-down"></i>
                        <i v-else class="fas fa-angle-up"></i>
                    </small>
                </span>
            </div>
        </a>
        <div :id="'collapseOne' + proj.pj_id" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion-items">
            <ul class="list-group list-group-flush border-top">
                <li v-for="item in proj.list" :key="item.id" class="list-group-item px-2 pb-1 pt-3">

                    <!-- もっとを見る -->
                    <more-info :item="item"></more-info>

                    <div class="text-muted">
                       <span>
                           <small> 名前: {{item.first_nm}} {{item.last_nm}} ({{item.first_kana}} {{item.last_kana}})</small>
                       </span>
                    </div>
                    <div class="text-muted">
                       <span v-if="item.in_flg != 'y'">
                           <small v-if="item.start_month"> 契約期間：{{formatDate(item.start_month,item.start_day)}} ~ {{formatDate(item.end_month,item.end_day)}}</small>
                           <small v-else> 契約期間：<span class="text-danger">未指定</span></small>
                       </span>
                    </div>
                    <div class="text-truncate">
                        {{item.name}}
                    </div>
                    <div class="text-muted d-flex let-space-1">
                        <small>
                            最終面接：{{item.in_d_last | dformatw}} {{item.in_h_last}}:{{item.in_m_last}}
                        </small>
                        <small v-if="item.add_flg == '1'" class="text-primary flex-fill text-right">法人側</small>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import MoreInfo from './More'

    export default {
        components: {
            MoreInfo
        },
        props: {
            proj: Object
        },
        data () {
            return {
                downIcon: true
            }
        },
        methods: {
            toggleIcon (id) {
                let list = '#collapseOne' + id
                if ($(list).hasClass('show')) {
                    this.downIcon = true
                } else {
                    this.downIcon = false
                }
            },
            formatDate (month, day) {
                let str = month + '/' + day
                return str.replace('-', '/')
            }
        }
    }
</script>

<style>
</style>
